import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { customStyles } from '../../tableStyles';
import '../css/ListRoles.css'

function RoleList() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [roleName, setRoleName] = useState('');
  const [roleType, setRoleType] = useState('');
  
  // Fetch role data from the server
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/roles`);
        
        const rolesData = response.data.roles || response.data.data || response.data || [];
        const sortedRoles = rolesData.sort((a, b) =>
           (a.role_name || "").localeCompare(b.role_name || "")
        );

        setRoles(sortedRoles);
        setFilteredRoles(sortedRoles);

      } catch (error) {
        console.error("Error fetching roles:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRoles();
  }, []);

  // Search handler
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = roles.filter(role =>
      (role.role_name || '').toLowerCase().includes(value) ||
      (role.role_type || '').toLowerCase().includes(value) // Handle potential null role_type
    );
    setFilteredRoles(filtered);
  };

  const handleAddRole = async (e) => {
  e.preventDefault();

  try {
    const apiUrl = process.env.REACT_APP_API_URL;

    const response = await axios.post(`${apiUrl}/roles/`, {
      role_name: roleName,
      role_type: roleType
    });

    const newRole = response.data.role || response.data;
;

    const updatedRoles = [...roles, newRole].sort((a, b) =>
      a.role_name.localeCompare(b.role_name)
    );
    setRoles(updatedRoles);
    setFilteredRoles(updatedRoles);
    
    setRoleName('');
    setRoleType('');
    setShowModal(false);
    
    alert("Role added successfully !!");
  } catch (error) {
    console.error("Error adding role:", error);
  }
};

  // Define columns for DataTable
  const columns = [
    {
      name: '#',
      cell: (row, index) => index + 1,
      width : '80px',
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    { name: 'Role Name', 
      selector: row => row.role_name, 
      sortable: true , 
      left : true
    },
  ];

  return (
    <div style={{ background: "transparent", padding: "0px" }}>
      <div className="d-flex justify-content-between mb-1" style={{ marginTop: "40px" }} >
        <div className="w-25 me-3 mb-1">
      {/* Search input */}
      <input
        type="text"
        placeholder="Search by role name or type"
        className = "roles-search-wrapper form-control search-input"
        value={searchTerm}
        onChange={handleSearch}
        style={{ border: "1px solid #000" }}
      />
    </div>  
      <button className="btn btn-warning add-role-btn"
      onClick={() => setShowModal(true)} >
        + Add Role
      </button>
      </div>
      <div className= "crm-roles-table-wrapper">
      <DataTable
        columns={columns}
        data={filteredRoles}
        progressPending={loading}
        pagination
        paginationPerPage={50}
        paginationComponentOptions={{ noRowsPerPage: true }}
        highlightOnHover
        striped
        responsive
        customStyles={customStyles} // Apply custom styles      
      />
      </div>

      {showModal && (
  <div className="role-modal-overlay">
    <div className="role-modal">

      <h5 className="mb-3">Add Role</h5>

      <form onSubmit={handleAddRole}>
        <div className="mb-2">
          <label>Role Name</label>
          <input
            type="text"
            className="form-control"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            required
          />
        </div>
        <div className="d-flex justify-content-end gap-2 role-modal-actions">
          <button
            type="button"
            className="btn btn-secondary role-modal-action-btn"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="btn btn-warning role-modal-action-btn"
          >
            Save
          </button>
        </div>
      </form>

    </div>
  </div>
)} 
    </div>    
  );
}  
export default RoleList;